import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { SlotsApi } from '../models/Agenda';
import { PaginatedResponse } from '@/types';

dayjs.extend(utc);

const renderSlotRange = ({ items }: PaginatedResponse<SlotsApi>) => {
  if (!Array.isArray(items) || items.length === 0) return <>Sin horarios</>;

  let earliestFrom = items[0].from;
  let latestTo = items[0].to;

  for (let i = 1; i < items.length; i++) {
    if (dayjs.utc(items[i].from).isBefore(dayjs.utc(earliestFrom)))
      earliestFrom = items[i].from;
    if (dayjs.utc(items[i].to).isAfter(dayjs.utc(latestTo)))
      latestTo = items[i].to;
  }

  const earliestFromFormatted = dayjs.utc(earliestFrom).format('HH:mm');
  const latestToFormatted = dayjs.utc(latestTo).format('HH:mm');

  return <>{`${earliestFromFormatted} - ${latestToFormatted}`}</>;
};

export default renderSlotRange;
